import { render, staticRenderFns } from "./ClaimAccountComplete.vue?vue&type=template&id=1b1ddd8e&scoped=true"
import script from "./ClaimAccountComplete.vue?vue&type=script&lang=ts"
export * from "./ClaimAccountComplete.vue?vue&type=script&lang=ts"
import style0 from "./ClaimAccountComplete.vue?vue&type=style&index=0&id=1b1ddd8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ddd8e",
  null
  
)

export default component.exports